import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "../Header/Header";
import React, {useEffect} from "react";
import { FaBook } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { FaLeaf } from "react-icons/fa";
import { FaWrench } from "react-icons/fa6";
import { IconContext } from "react-icons";

import SiderHome, {ImageSlider} from "../Sider/SiderHome";
import "./Home.css";
import Footer from "../Footer/Footer";
import {useLocation} from "react-router";

export default function () {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [hash]);

    return <>
        <Header/>
        <ImageSlider/>
        <h1 className={"mt-2 p-3"}>Welcome</h1>
        <p className={"mt-2 p-3 indent"}>
            <strong>
                आम्ही ग्रामपंचायत मधील मालमत्ता धारकांच्या जागेचे व बांधकामाचे चातेक्षेत्राफालानुसार मोज माप करून सोफतवारे मध्ये नमुना ८,९ व नमुना १० कर मागणी पावती बनवून देतो.
            </strong>
            <br/>
            तसेच डिजिटल इंडिया digitization कार्यक्रम अंतर्गत ग्रामपंचायत पातडीवरती सगडी माहिती online वेब पोर्टल द्वारे कुठेही आणी कधीही बघता येते. या website द्वारे ग्रामपंचायत पातडीवरील नमुना ८,९ तसेच १० online भरने , प्रिंट करणे तसेच SMS अलर्ट द्वारे डेटा रेकॉर्ड ची माहिती दररोज मोबाइल वरती प्राप्त होईल .
        </p>

        <IconContext.Provider value={{ color: "blue", size: "100px" }}>
            <div id={"service"} className="container mt-4 ">
                {/*====================Row1============*/}
                <div className="row">
                    {/*==========================Column1==============*/}
                    <div className="col-md-6 col-12  text-white mb-3 ">

                        <div className="text-center card p-3 h-100 d-flex flex-column">
                            <div className={"mb-3"}>
                                <FaWrench />
                            </div>
                            <div >
                            <span className="h1">
                                नमुना ८ चे वैशिष्ट्ये
                            </span>
                            </div>
                            <hr/>
                            <ul className="text-start" >
                                <li>   नमुना ८ मध्ये मालमत्ता धारकांचे तसेच जागेचे,बांधकामाचे व चतु:सिमासांचे संपूर्ण नोंद होते.</li>
                                <li>   खाली जागा (ओपन प्लॉट) असल्यास फक्त भूमिकाराचीच नोंद होते.  </li>
                                <li>   एकाच प्लॉट मध्ये दोन किंवा जास्त बांधकाम असल्यास एकाच नमुना ८ मध्ये नोंद होते. </li>
                                <li>   इमारत बहु माजली असल्यास प्रत्येक मजल्याचे क्षेत्रफळाची स्वतंत्रपणे नोंद घेऊन कर आकारणी होते. </li>
                                <li>   उद्योगधंदे व व्यवसाय असल्यास त्याचे स्वतंत्रपणे नोंद होते.</li>
                                <li>   घरकुल किवा जनावरांचा गोठा असल्यास त्याचे स्वतंत्रपणे नोंद होते.</li>
                                <li>   शासकीय, सामाजिक तसेच ग्रामपंचायतीची मालमत्ता ज्याच्यावर कर लागू नाही त्याची स्वतंत्रपणे नोंद होते.</li>
                                <li>   शासकीय जागेवर अतिक्रमण असल्यास मालमत्ता धर्काचे नाव सरकार म्हणून नोंद होते</li>.
                                <li>   बांधकामाच्या क्षेत्रफळानुसार विजकर व आरोग्याकाराची स्वतंत्रपणे नोंद होते.</li>
                                <li>   विशेष शेरा याची स्वतंत्रपणे नोंद घेता येते.                          </li>
                                <li>   मालमत्ताधारकांची हरकत/आक्षेप व प्रसिद्धी करिता वैयक्तिक जाहीर सूचना व प्रारूप यादी प्रिंट करू शकतो.   </li>
                            </ul>


                        </div>

                    </div>

                    {/*==========================Column2==============*/}
                    <div className="col-md-6 col-12  text-white mb-3 ">

                        <div className="text-center card p-3 h-100 d-flex flex-column">
                            <div className={"mb-3"}>
                                <FaLeaf />
                            </div>
                            <div >
                            <span className="h1">
                                नामुमा ८ चे फायदे
                            </span>
                            </div>
                            <hr/>
                            <ul className="text-start">

                                <li> ग्रामपंचायतने कर आकारणी केलेल्या कारच्या प्रकारानुसार गोषवारा प्रिंट होते.     	</li>
                                <li> ग्रामपंचायत मधिल मालमत्ता प्रकारानुसार गोषवारा प्रिंट होते.   	</li>
                                <li> ग्रामपंचायत मधील मालमत्ता प्रकारानुसार यादी प्रिंट होते.      	</li>
                                <li> ग्रामपंचायत मधील नळ कनेक्शन असलेल्या/नसलेल्या मालमत्ता धारकांची यादी प्रिंट होते. 	</li>
                                <li> पाहिजे त्या क्रमांक चा नमुना प्रिंट करू शकतो.     	</li>
                                <li> दाता बेस फआइल मधून मालमत्ता धारकांचा दाता कोणत्याही सोफ्तवारे मधे लोड करू शकतो.  	</li>
                            </ul>
                        </div>

                    </div>

                </div>
                {/*====================Row2============*/}
                <div className="row">
                    {/*==========================Column1==============*/}
                    <div className="col-md-6 col-12  text-white mb-3 ">

                        <div className="text-center card p-3 h-100 d-flex flex-column">
                            <div className={"mb-3"}>
                                <FaEdit />
                            </div>
                            <div >
                            <span className="h1">
                                ग्रामपंचायतला पुरविण्यात येणारे साहित्य
                            </span>
                            </div>
                            <hr/>
                            <ul className="text-start">
                                <li>    मालमत्ता धारकांच्या जागेचे व बांधकामाचे मोज माप करून नमुना ८ चे संगणीकृत  रेकॉर्ड .</li>
                                <li>         संगणीकृत प्रितिनगची प्रत प्लासिक बाईंडिंग रजिस्टर.</li>
                                <li>          संगणीकृत रेकॉर्ड्स ची सीडी ज्यामध्ये दाता बेस फेल व प्रिंट फील. </li>
                                <li>          मोज माप केलेले मालमत्ता धारकांची सही असलेले हस्तलिखित अर्ज.    </li>
                            </ul>
                        </div>

                    </div>

                    {/*==========================Column2==============*/}
                    <div className="col-md-6 col-12  text-white mb-3 ">

                        <div className="text-center card p-3 h-100 d-flex flex-column">
                            <div className={"mb-3"}>
                                <FaBook />
                            </div>
                            <div >
                            <span className="h1">
                                पंचायत समिती अंतर्गत येणाऱ्या सर्व ग्रामपंचायत मधील नमुना ८ चे संगणीकृत रेकोर्ड करून घेतल्याचे फायदे.
                            </span>
                            </div>
                            <hr/>
                            <ul className="text-start">
                                <li>    ग्रामपंचायत ने कर आकारणी केलेल्या कारच्या प्रकारानुसार ग्रामपंचायत निहाय गोषवारा प्रिंट होते.</li>
                                <li>    ग्रामपंचायत मधील मालमत्ता प्रकारानुसार ग्रामपंचायत निहाय गोषवारा प्रिंट होते.</li>
                                <li>    संपूर्ण ग्रामपंचायत समितीचा काराच्या प्रकरानुसार तसेच मालमत्ता प्रकारानुसार गोषवार अप्रींत होतो. </li>
                                <li>    ग्रामपंचायत मधील नळ कनेक्शन असलेल्या/नसलेल्या मालमत्ता धारकांचा ग्रामपंचायत निहाय तसेच संपूर्ण पंचायत समितीचा गोषवारा प्रिंट होतो.</li>

                            </ul>
                        </div>

                    </div>

                </div>

            </div>

        </IconContext.Provider>;

        <Footer/>
    </>
}
